import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { PageSource } from '../../model/enum/enums';
import { adsActions } from '../../store/slices/adsSlice';
import { RootState } from '../../store/store';

export const useAds = () => {
    const dispatch = useDispatch();
    const { pageSource, showAds } = useSelector((state: RootState) => state.ads);
    const ac = bindActionCreators(adsActions, dispatch);

    const setPageSource = (source: PageSource) => {
        ac.setPageSource(source);
    };

    const setShowAds = (show: boolean) => {
        ac.setShowAds(show);
    };

    return {
        pageSource,
        showAds,
        setPageSource,
        setShowAds
    };
};
